import { useMutation } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const MUTATION = graphql(`
  mutation UpdatePageRule($id: ID!, $input: UpdatePageRuleInput!) {
    updatePageRule(id: $id, input: $input) {
      id
    }
  }
`);

export function useUpdatePageRule() {
  return useMutation(MUTATION, {
    refetchQueries: ['PrintRule', 'PageRule', 'PageRuleData'],
  });
}
